import { Coord } from "../../../../../../../src/types/Interface";
import rotateCoordinate from "../../../../../../../src/utils/coord/rotateCoordinate";


export default function genRotatedShape(pivotPoint: Coord, shapePoints: Coord[], rotation: number){
  return [...shapePoints].map(c => rotateCoordinate(c, pivotPoint, rotation));
}